import { useEffect, useState } from 'react';
import { customerService } from '@services/api/customerService';
import { formatCurrency, maskCardNumber } from '@/types/customer';
import type { Card } from '@/types/customer';
import '../CustomerTabs.css';

interface CardsTabProps {
  customerId: string;
}

export const CardsTab = ({ customerId }: CardsTabProps) => {
  const [cards, setCards] = useState<Card[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCards();
  }, [customerId]);

  const loadCards = async () => {
    const result = await customerService.getCustomerCards(customerId);
    if (result.success && result.data) {
      setCards(result.data);
    }
    setLoading(false);
  };

  if (loading) return <div>Loading cards...</div>;
  if (cards.length === 0) return <div>No cards found</div>;

  return (
    <div className="tab-content-wrapper">
      {cards.map((card) => (
        <div key={card.id} className="info-card">
          <h3 className="info-card-title">
            💳 {card.card_type} Card ({maskCardNumber(card.card_number)})
          </h3>
          
          <div className="info-grid">
            <div className="info-item">
              <span className="info-label">Status</span>
              <span className={`status-badge status-${card.card_status === 'ACTIVE' ? 'green' : 'red'}`}>
                {card.card_status}
              </span>
            </div>
            <div className="info-item">
              <span className="info-label">Card Type</span>
              <span className="info-value">{card.card_type}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Expires</span>
              <span className="info-value">{card.expiry_date || 'N/A'}</span>
            </div>
            <div className="info-item">
              <span className="info-label">Daily Limit</span>
              <span className="info-value">{formatCurrency(Number(card.daily_transaction_limit))}</span>
            </div>
            <div className="info-item">
              <span className="info-label">ATM Limit</span>
              <span className="info-value">{formatCurrency(Number(card.daily_atm_withdrawal_limit))}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

